/* Grade buying allocates existing Shopify variants. It never creates pooled inventory. */
(function () {
  'use strict';
  function stock(variants, cart, key) {
    var rows = variants.filter(function (v) { return v.key === key; }).map(function (v) {
      var used = cart.items.reduce(function (n, item) {
        return n + (String(item.variant_id) === String(v.id) ? item.quantity : 0);
      }, 0);
      var cap = Math.max(0, Math.min(v.stock, v.max == null ? v.stock : v.max) - used);
      return Object.assign({}, v, { used: used, cap: cap });
    });
    if (!key || !rows.length || rows.length > 2 || new Set(rows.map(function (v) { return v.box; })).size !== rows.length) {
      throw new Error('This grade needs checking. Please call us to order.');
    }
    return rows.sort(function (a, b) { return (a.box === 'Brown Box' ? 0 : 1) - (b.box === 'Brown Box' ? 0 : 1); });
  }
  function valid(row, quantity) {
    return quantity === 0 || (quantity <= row.cap && quantity + row.used >= row.min && (quantity + row.used) % row.step === 0);
  }
  function unit(row, quantity) {
    return row.breaks.reduce(function (price, b) { return quantity + row.used >= b.min ? Math.min(price, b.price) : price; }, row.price);
  }
  function plan(rows, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 1) return null;
    var a = rows[0], b = rows[1], best = null;
    // At most two packaging variants. Prefer the lowest quoted total, brown box on a tie.
    for (var n = Math.min(quantity, a.cap); n >= Math.max(0, quantity - (b ? b.cap : 0)); n--) {
      var other = quantity - n;
      if (!valid(a, n) || (b ? !valid(b, other) : other !== 0)) continue;
      var items = [];
      if (n) items.push({ id: a.id, quantity: n });
      if (other) items.push({ id: b.id, quantity: other });
      var total = n * unit(a, n) + (other ? other * unit(b, other) : 0);
      if (!best || total < best.total) best = { items: items, total: total };
    }
    return best;
  }
  function bounds(rows) {
    var max = rows.reduce(function (n, v) {
      var cap = v.cap - ((v.cap + v.used) % v.step);
      return n + (valid(v, cap) ? Math.max(0, cap) : 0);
    }, 0);
    var min = Math.min.apply(null, rows.map(function (v) {
      var n = Math.max(1, v.min - v.used);
      n += (v.step - ((n + v.used) % v.step)) % v.step;
      return valid(v, n) ? n : Infinity;
    }));
    return { min: Number.isFinite(min) ? min : 1, max: max };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { stock: stock, plan: plan, bounds: bounds }; return; }

  var states = new WeakMap();
  var posting = false; // Serialize writes across grade forms in this page.
  function state(box) {
    if (!states.has(box)) {
      states.set(box, { data: JSON.parse(box.dataset.gradeStock), cart: { items: [] }, busy: false, uncertain: false });
    }
    return states.get(box);
  }
  function notice(box, message) {
    var el = box.querySelector('[data-row-notice], [data-add-notice]');
    el.style.color = '';
    el.textContent = message; el.hidden = !message;
  }
  function money(box, cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: box.dataset.currency || 'GBP' }).format(cents / 100);
  }
  function render(box, reset) {
    var s = state(box), rows = stock(s.data.variants, s.cart, box.dataset.gradeKey), range = bounds(rows);
    var input = box.querySelector('[name="quantity"], [data-qty]');
    var button = box.querySelector('[data-row-add], #addBtn');
    input.min = range.min; input.max = range.max; input.step = 1; input.readOnly = range.max <= range.min;
    if (reset) input.value = Math.min(range.max, range.min);
    var quantity = Number(input.value), quote = plan(rows, quantity);
    input.disabled = s.busy || s.uncertain || range.max < range.min;
    button.disabled = input.disabled || !quote;
    box.querySelectorAll('[data-row-step], [data-step]').forEach(function (btn) {
      var direction = Number(btn.dataset.rowStep || btn.dataset.step);
      btn.disabled = input.disabled || (direction < 0 ? quantity <= range.min : quantity >= range.max);
    });
    var consumer = box.dataset.consumer === '1', warranty = box.querySelector('input[name="warr"]:checked');
    var tax = consumer ? 1.2 : 1;
    var total = quote ? quote.items.reduce(function (sum, item) {
      var row = rows.find(function (v) { return String(v.id) === String(item.id); });
      return sum + Math.round(item.quantity * unit(row, item.quantity) * tax);
    }, 0) : 0;
    if (warranty) total += Math.round(Number(warranty.dataset.wnet || 0) * quantity * tax);
    box.querySelectorAll('[data-option-price], [data-sum-total], [data-add-total], [data-price-out]').forEach(function (el) { el.textContent = quote ? money(box, total) : '—'; });
    if (warranty) {
      box.querySelectorAll('.wopt').forEach(function (el) { el.classList.toggle('on', el.contains(warranty)); });
      box.querySelector('[data-wsum]').textContent = warranty.dataset.wsummary;
      var term = box.querySelector('[data-warranty-term]');
      if (term) term.textContent = warranty.dataset.wterm;
    }
    // Native price breaks are per SKU, not a promise of a pooled grade discount.
    box.querySelectorAll('#vbreaks, #moq').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
    if (!range.max && !s.busy && !s.uncertain) notice(box, 'No further units of this grade are available to add.');
    return { rows: rows, quote: quote, total: total, range: range };
  }
  async function json(url) {
    // The alternate Liquid view emits JSON itself. An application/json Accept
    // header makes Shopify serve its standard product JSON instead of that view.
    var response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check availability. Please refresh and try again.');
    return response.json();
  }
  async function refresh(box) {
    var s = state(box), url = new URL(box.dataset.productUrl, window.location.origin);
    url.searchParams.set('view', 'grade-stock');
    url.searchParams.set('_', Date.now());
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    var result = await Promise.all([json(url.pathname + url.search), json(box.dataset.cartUrl + '.js')]);
    if (result[0].product !== s.data.product || !Array.isArray(result[0].variants) || !Array.isArray(result[1].items)) {
      throw new Error('Availability or account access has changed. Please refresh this page.');
    }
    s.data = result[0]; s.cart = result[1];
  }
  async function add(box) {
    var s = state(box);
    if (posting || s.busy || s.uncertain) return;
    var input = box.querySelector('[name="quantity"], [data-qty]'), quantity = Number(input.value);
    var before = render(box, false);
    if (!before.quote) { notice(box, 'Choose an available quantity for this grade.'); return; }
    var feedback = window.HciCartFeedback;
    if (!feedback || !feedback.begin(box)) return;
    posting = true; s.busy = true; notice(box, 'Checking availability…'); render(box, false);
    var attempted = false, added = false, confirmed = false;
    try {
      await refresh(box);
      var after = render(box, false);
      if (!after.quote) throw new Error('Stock has changed. Choose a smaller quantity or refresh the page.');
      if (after.total !== before.total) throw new Error('The total has changed. Review the updated total, then add to your basket.');
      var items = after.quote.items;
      var warranty = box.querySelector('input[name="warr"]:checked');
      if (box.dataset.consumer === '1') {
        items = items.map(function (item) { return Object.assign({}, item, { properties: { Warranty: warranty ? warranty.dataset.wlabel : '12 months return-to-base' } }); });
        if (warranty && warranty.value) items.push({ id: warranty.value, quantity: quantity });
      }
      attempted = true;
      var response = await fetch(box.dataset.cartUrl + '/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!response.ok) {
        // Shopify may have changed the cart even when an add reports an error.
        s.uncertain = true;
        throw new Error('Availability changed while adding. Check your basket before ordering more.');
      }
      added = true;
      // Keep the form locked until the real basket has been read back.
      s.uncertain = true;
      s.cart = await feedback.refresh(box.dataset.cartUrl);
      s.uncertain = false; confirmed = true;
    } catch (error) {
      if (attempted) { s.uncertain = true; feedback.unknown(); }
      feedback.notice(box, added ? 'Added to your basket, but we could not refresh it. Check your basket before adding more.' :
        attempted ? 'We could not confirm the full addition. Check your basket before ordering more.' : error.message, attempted);
    } finally {
      s.busy = false; posting = false; feedback.end(); render(box, confirmed);
      if (confirmed) feedback.added(box, quantity);
    }
  }
  document.addEventListener('hci:cart-updated', function (event) {
    document.querySelectorAll('[data-grade-key]').forEach(function (box) {
      if (!states.has(box)) return;
      state(box).cart = event.detail;
      try { render(box, false); } catch (error) { notice(box, 'Please refresh to check this grade.'); }
    });
  });
  function initialise(root) {
    root.querySelectorAll('[data-grade-key]').forEach(function (box) {
      if (states.has(box)) return;
      try { render(box, true); }
      catch (error) { notice(box, 'Please call us to order this grade.'); }
    });
  }
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-row-toggle]');
    if (toggle) initialise(toggle.closest('.prow'));
    var box = event.target.closest('[data-grade-key]');
    if (!box) return;
    var step = event.target.closest('[data-row-step], [data-step]');
    if (step) {
      event.preventDefault();
      var input = box.querySelector('[name="quantity"], [data-qty]'), current = render(box, false);
      var direction = Number(step.dataset.rowStep || step.dataset.step), next = Number(input.value) + direction;
      while (next >= current.range.min && next <= current.range.max && !plan(current.rows, next)) next += direction;
      if (next >= current.range.min && next <= current.range.max) input.value = next;
      notice(box, ''); render(box, false);
    }
    if (event.target.closest('#addBtn')) { event.preventDefault(); add(box); }
  });
  document.addEventListener('submit', function (event) {
    var box = event.target.closest('form[data-grade-key]');
    if (box) { event.preventDefault(); add(box); }
  });
  ['input', 'change'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var box = event.target.closest('[data-grade-key]');
      if (box) { notice(box, ''); render(box, false); }
    });
  });
  initialise(document);
}());
